(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sl-floating-cart"] && !Shopify.designMode) return;
  try {
    (function () {
    var bar = document.querySelector('.sl-fcart');
    if (!bar) return;
    var countEl = bar.querySelector('.sl-fcart__count');
    var totalEl = bar.querySelector('.sl-fcart__total');
    var bag = document.querySelector('.sl-fbag');
    var bagCountEl = bag && bag.querySelector('.sl-fbag__count');
    var checkout = document.querySelector('.sl-fcheckout');
    var checkoutCountEl = checkout && checkout.querySelector('.sl-fcheckout__count');
    var checkoutTotalEl = checkout && checkout.querySelector('.sl-fcheckout__total');
    var barShown = false;

    function money(cents) {
      return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    // Redundant on the cart/checkout pages themselves.
    function onCartPage() {
      return /\/cart($|\/|\?)/.test(location.pathname) || location.pathname.indexOf('/checkout') === 0;
    }

    // Lift whichever chat-launcher generation is present above the floating cart bar / bag / sticky
    // checkout so they don't overlap. Shopify Inbox has shipped three, and the launcher can swap
    // between them live:
    //  - `#ShopifyChat`: a fixed element in the light DOM → moved by `.sl-chat-lift` on <html> plus
    //    the stylesheet rule above.
    //  - A glass "Need help?" nudge (`.activator-nudge`) in an open shadow root — sometimes directly
    //    under <shopify-chat>, and sometimes re-mounted into a nested <shopify-agent-runtime> shadow
    //    once the chat is first opened. It animates its own `transform`, so it must be lifted via
    //    `bottom` (which it leaves alone) — a `transform` override loses to the running animation
    //    even with `!important`.
    // A page stylesheet can't cross shadow boundaries, so inject the rule into every shadow root
    // under <shopify-chat> that holds a nudge, and re-inject on any chat mutation — the launcher hops
    // shadow roots as the chat is opened and closed, so a one-shot inject would strand it.
    var shiftOn = false;
    var observedRoots = [];
    var LIFT_CSS =
      '.activator-nudge{transition:bottom .32s cubic-bezier(.4,0,.2,1)!important;bottom:80px!important}';

    function collectRoots(root, acc) {
      acc.push(root);
      root.querySelectorAll('*').forEach(function (element) {
        if (element.shadowRoot) collectRoots(element.shadowRoot, acc);
      });
      return acc;
    }

    var liftPending = false;
    function scheduleChatLift() {
      if (liftPending) return;
      liftPending = true;
      requestAnimationFrame(function () { liftPending = false; applyChatLift(); });
    }

    function observeRoot(root) {
      if (observedRoots.indexOf(root) !== -1) return;
      observedRoots.push(root);
      try {
        new MutationObserver(scheduleChatLift).observe(root, { childList: true, subtree: true });
      } catch (error) {}
    }

    function applyChatLift() {
      var host = document.querySelector('shopify-chat');
      if (!host || !host.shadowRoot) return;
      collectRoots(host.shadowRoot, []).forEach(function (root) {
        observeRoot(root);
        var existing = root.getElementById('sl-fcart-chat-style');
        if (shiftOn && root.querySelector('.activator-nudge')) {
          if (!existing) {
            var style = document.createElement('style');
            style.id = 'sl-fcart-chat-style';
            style.textContent = LIFT_CSS;
            root.appendChild(style);
          }
        } else if (existing) {
          existing.remove();
        }
      });
    }

    function setChatShift(on) {
      shiftOn = !!on;
      document.documentElement.classList.toggle('sl-chat-lift', shiftOn);
      applyChatLift();
    }

    function render(cart) {
      var count = (cart && cart.item_count) || 0;
      var onCart = onCartPage();
      barShown = count > 0 && !onCart;
      var checkoutShown = count > 0 && onCart;
      if (barShown) {
        countEl.textContent = count === 1 ? '1 item' : count + ' items';
        totalEl.textContent = money(cart.total_price);
        bar.classList.add('sl-fcart--in');
        if (bagCountEl) bagCountEl.textContent = count;
        if (bag) bag.classList.add('sl-fbag--in');
      } else {
        bar.classList.remove('sl-fcart--in');
        if (bag) bag.classList.remove('sl-fbag--in');
      }
      if (checkout) {
        if (checkoutShown) {
          if (checkoutCountEl) checkoutCountEl.textContent = count === 1 ? '1 item' : count + ' items';
          if (checkoutTotalEl) checkoutTotalEl.textContent = money(cart.total_price);
          checkout.classList.add('sl-fcheckout--in');
        } else {
          checkout.classList.remove('sl-fcheckout--in');
        }
      }
      setChatShift(barShown || checkoutShown);
      // Pad the page bottom so the fixed bar doesn't hide the footer (policy/contact links) on mobile.
      document.documentElement.classList.toggle('sl-fbar-open', barShown || checkoutShown);
    }

    function refresh() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(render)
        .catch(function () {});
    }

    // The cart page changes quantities / removes items via fetch — without reloading and without
    // firing our `sl:cart-updated` event — so the bar would keep a stale count (e.g. still showing
    // "2 items" on an emptied cart). Wrap fetch to re-sync after any cart-mutating request, so the bar
    // always matches the real cart. /cart.js (a read) is ignored, so refresh() can't loop.
    var nativeFetch = typeof window.fetch === 'function' ? window.fetch.bind(window) : null;
    if (nativeFetch) {
      window.fetch = function () {
        var target = arguments[0];
        var url = target && (target.url || target);
        // nativeFetch is bound to window, so a bare `fetch()` from a strict-mode module can't trip
        // "Illegal invocation" here.
        var response = nativeFetch.apply(null, arguments);
        if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/i.test(url)) {
          response.then(function () { setTimeout(refresh, 60); }, function () {});
        }
        return response;
      };
    }

    // Loading feedback: on click, flip the tapped control's arrow/icon to a spinner so the wait reads
    // as "loading", not "frozen". Cleared on bfcache restore; an 8s failsafe drops it if navigation
    // never happens (e.g. a checkout that opens an overlay in place).
    function markLoading(element) {
      element.classList.add('sl-loading');
      setTimeout(function () { element.classList.remove('sl-loading'); }, 8000);
    }
    // The bar and bag are links. Browsers routinely skip the repaint between the click handler and the
    // navigation, so a class added here never paints — the spinner wouldn't show. Hold the navigation
    // for one painted frame so it does. Modified clicks (new tab / middle-click) fall through untouched.
    function holdForSpinner(link) {
      link.addEventListener('click', function (event) {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        var href = link.href;
        markLoading(link);
        var navigated = false;
        function go() { if (navigated) return; navigated = true; window.location.assign(href); }
        // Navigate after one painted frame so the spinner is visible; fall back to a timer in case rAF
        // is throttled (e.g. a backgrounded tab) so the link can never appear dead.
        requestAnimationFrame(function () { requestAnimationFrame(go); });
        setTimeout(go, 300);
      });
    }
    if (bar) holdForSpinner(bar);
    if (bag) holdForSpinner(bag);
    // The checkout submits the cart form (which a checkout app may hook), so don't intercept it — just
    // mark it. On this store it opens an in-place overlay rather than navigating, so its spinner paints.
    if (checkout) checkout.addEventListener('click', function () { markLoading(checkout); });

    refresh();
    // Fired by the homepage reskin's AJAX add/stepper.
    document.addEventListener('sl:cart-updated', function (event) { render(event.detail); });
    // Re-check when returning via back/forward cache, and drop any stale spinner from before we left.
    window.addEventListener('pageshow', function () {
      refresh();
      [bar, bag, checkout].forEach(function (element) { if (element) element.classList.remove('sl-loading'); });
    });
    // The legacy launcher's shadow root can attach a few seconds after load; re-apply so the shadow
    // injection lands once it exists. (The light-DOM launcher needs no retry — CSS applies itself.)
    [1500, 4000, 8000, 14000].forEach(function (delay) {
      setTimeout(function () { setChatShift(shiftOn); }, delay);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
